//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CodingTop from '@/components/redesign/coding/CodingTop'
import VideoSection from '@/components/partner/VideoSection'
import TeacherSection from '@/components/partner/TeacherSection'
import MapSection from '@/components/partner/MapSection'
import QuestionsSection from '@/components/partner/QuestionsSection'
import FeedbackSection from '@/components/partner/FeedbackSection'
import SignupSection from '@/components/partner/SignupSection'
import { mapState } from 'vuex'

export default {
  name: 'CodingPage',
  components: {
    CodingTop,
    VideoSection,
    TeacherSection,
    MapSection,
    QuestionsSection,
    FeedbackSection,
    SignupSection,
  },
  computed: {
    ...mapState(['i18n']),
  },
  methods: {
    getTag() {
      if (this.$i18n.locale === 'ru') {
        return 'Программирование'
      }
      return 'Programming'
    },
  },
}
